import * as _colors from './colors';

export const colors = _colors;
